import { ChangeDetectionStrategy, Component, contentChild, input, TemplateRef } from '@angular/core';
import { ComponentStatus } from '../state/state.component';
import { NgTemplateOutlet } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'oo-loading-container',
  templateUrl: './loading-container.component.html',
  styleUrls: ['./loading-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressSpinner, NgTemplateOutlet],
})
export class LoadingContainerComponent {
  private static DEFAULT_ERROR_MSG = 'There was an issue please try later';

  status = input<ComponentStatus>('ready');
  errorMessage = input(LoadingContainerComponent.DEFAULT_ERROR_MSG);
  diameter = input(100);

  readonly detailRef = contentChild(TemplateRef);
}
